export class DialogModelADN {
    constructor(
      public data:any
    ) {}
  }